export function dateRangeToDays(startDate: Date, endDate: Date): { startDate: number; endDate: number } {
    const today: Date = new Date();
    const daysAgo = (date: Date): number => Math.floor((today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    return {
      startDate: daysAgo(startDate),
      endDate: daysAgo(endDate)
    }
  }